import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

// ** Icons Imports
import WeatherNight from "mdi-material-ui/WeatherNight";
import WeatherSunny from "mdi-material-ui/WeatherSunny";

/******************************************************************
 * ##: ModeToggler
 * AppBar control that toggles light / dark mode. Styled as a soft
 * rounded button with an accent hover, to match the style-v3 header.
 * @param {Object} props - settings / saveSettings
 * @returns {JSX.Element} - the theme toggle button
 * History:
 * 05-07-2026: Restyled (rounded button, tooltip, accent hover)
 ******************************************************************/
const ModeToggler = (props) => {
  // ** Props
  const { settings, saveSettings } = props;

  const isDark = settings.mode === "dark";

  const handleModeToggle = () => {
    saveSettings({ ...settings, mode: isDark ? "light" : "dark" });
  };

  return (
    <Tooltip title={isDark ? "Modo claro" : "Modo escuro"} arrow>
      <IconButton
        onClick={handleModeToggle}
        aria-label={isDark ? "Ativar modo claro" : "Ativar modo escuro"}
        sx={{
          width: 40,
          height: 40,
          color: "text.secondary",
          borderRadius: "12px",
          transition: "color .2s, background-color .2s",
          "&:hover": {
            color: "primary.main",
            backgroundColor: (theme) => `${theme.palette.primary.main}14`,
          },
        }}
      >
        {isDark ? <WeatherSunny /> : <WeatherNight />}
      </IconButton>
    </Tooltip>
  );
};

export default ModeToggler;
